module.exports = __webpack_public_path__ + "media/images/logo-pc-d95da2dd1872e2ae9c6442c2fa32360d.png";